import { AdSlot } from '@fe-cnyes/fe-dfp';

const BaseDynamicAd = AdSlot;

export default BaseDynamicAd;
